import { supabase } from '../supabaseClient';
import type { AuthChangeEvent, Session } from '@supabase/supabase-js';
import { clearSessionTimeoutState } from '../utils/sessionTimeout';

export const authService = {
  async signIn(email: string, password: string) {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
    if (error) throw error;
    return data;
  },

  async signUp(email: string, password: string) {
    const { data, error } = await supabase.auth.signUp({
      email,
      password,
    });
    if (error) throw error;
    return data;
  },

  async requestPasswordReset(email: string, redirectTo: string, language?: string) {
    // Sent through the request-password-reset edge function (Resend) because the
    // Supabase built-in mailer does not deliver to customer inboxes.
    const { data, error } = await supabase.functions.invoke('request-password-reset', {
      body: { email, redirectTo, language },
    });
    if (error) throw error;
    return data;
  },

  async updatePassword(password: string) {
    const { data, error } = await supabase.auth.updateUser({
      password,
    });
    if (error) throw error;
    return data;
  },

  async signOut() {
    const { error } = await supabase.auth.signOut({ scope: 'local' });
    clearSessionTimeoutState();
    if (error) throw error;
  },

  getCurrentUser() {
    return supabase.auth.getUser();
  },

  async getCurrentUserEmail(): Promise<string | undefined> {
    const { data: { user } } = await supabase.auth.getUser();
    return user?.email;
  },

  onAuthStateChange(callback: (event: AuthChangeEvent, session: Session | null) => void) {
    return supabase.auth.onAuthStateChange(callback);
  },
};
